import { notifyAdminStudentLogin, notifyAdminDeviceApproval, notifyStudentDevicePending } from './notifications';
import {
  getDeviceFingerprint,
  getDeviceLabel,
  getStudentSecurityProfile,
  isDeviceApproved,
  requestDeviceApproval,
} from './studentSecurity';

/**
 * Run after a successful student login: notify admin, enforce device approval.
 */
export async function handleStudentPostLogin(user) {
  if (!user?.uid) return { blocked: false, devicePending: false };

  const profile = await getStudentSecurityProfile(user.uid);
  if (profile?.portalBlocked) {
    return { blocked: true, devicePending: false, reason: profile.blockReason };
  }

  await notifyAdminStudentLogin({
    displayName: user.displayName || profile?.displayName,
    email: user.email || profile?.email,
    userId: user.uid,
  }).catch(console.warn);

  const deviceId = getDeviceFingerprint();
  const approved = await isDeviceApproved(user.uid, deviceId);

  if (!approved) {
    const hasApprovedList = (profile?.approvedDevices || []).length > 0;
    if (hasApprovedList) {
      await requestDeviceApproval(user.uid, deviceId, getDeviceLabel());
      await notifyAdminDeviceApproval({
        studentName: user.displayName || profile?.displayName,
        email: user.email || profile?.email,
        userId: user.uid,
        deviceLabel: getDeviceLabel(),
      }).catch(console.warn);
      await notifyStudentDevicePending(user.uid).catch(console.warn);
      return { blocked: false, devicePending: true, deviceId };
    }
    // First device — auto-approve
    const { approveStudentDevice } = await import('./studentSecurity');
    await approveStudentDevice(user.uid, deviceId);
  }

  return { blocked: false, devicePending: false };
}
